import { Component, Input } from '@angular/core';
import { ControlValueAccessor } from "@angular/forms";
import { SendOption } from "@models/annual-statements/annual-statement-enums";
import { IntegrationConnectionsEnum } from "@models/integrations/integration-connections.enum";
import { SelectOption } from "@models/ui-models/select-options";
import { RadioComponent } from "@shared/controls/radio/radio.component";
import { ValidationErrorComponent } from "@shared/controls/validation-error/validation-error.component";

export const generateDocumentsSendByOptions: SelectOption<SendOption>[] = [
  { label: 'eSign', value: SendOption.Sign, disabled: false },
  { label: 'Email', value: SendOption.Email, disabled: false },
  { label: 'Paper', value: SendOption.Paper, disabled: false },
];

export const eSignSourceClasses: Partial<Record<IntegrationConnectionsEnum, string>> = {
  [IntegrationConnectionsEnum.XpmConnection]: 'xpm',
  [IntegrationConnectionsEnum.AnnatureConnection]: 'annature',
  [IntegrationConnectionsEnum.DocuSignConnection]: 'docusign',
};

export const eSignSourceNames: Partial<Record<IntegrationConnectionsEnum, string>> = {
  [IntegrationConnectionsEnum.XpmConnection]: 'XPM',
  [IntegrationConnectionsEnum.AnnatureConnection]: 'Annature',
  [IntegrationConnectionsEnum.DocuSignConnection]: 'DocuSign',
};

@Component({
  selector: 'app-send-by-radio',
  standalone: true,
  imports: [
    ValidationErrorComponent,
  ],
  templateUrl: 'send-by-radio.component.html',
  styleUrls: [
    'send-by-radio.component.scss',
    '../../../controls/radio/radio.component.scss'
  ]
})
export class SendByRadioComponent extends RadioComponent implements ControlValueAccessor {
  @Input() override label = 'Send By';
  @Input() override options: SelectOption<SendOption>[] = generateDocumentsSendByOptions;
  @Input() eSignSource: IntegrationConnectionsEnum | null = null;
  @Input() isLoading = false;

  readonly SendOption = SendOption;

  get eSignSourceClass(): string | null {
    return eSignSourceClasses[this.eSignSource!] ?? null;
  }

  get eSignSourceName(): string | null {
    return eSignSourceNames[this.eSignSource!] ?? null;
  }
}
